<template><div><h2 id="usage" tabindex="-1" class="d-docsite--header-2">Usage <a class="header-anchor d-link d-docsite--link d-link" href="#usage" aria-hidden="true">#</a></h2>
<p class="d-docsite--paragraph">Use <code v-pre>d-ol-{focusring|focusring-inset|none}</code> to change an elements' outline.</p>
<code-example source-code='&lt;dt-stack direction=&quot;row&quot; align=&quot;center&quot; justify=&quot;center&quot; class=&quot;d-p-200 d-bgc-moderate d-code--sm d-ol-focusring&quot;&gt;
  .d-ol-focusring
&lt;/dt-stack&gt;
&lt;dt-stack direction=&quot;row&quot; align=&quot;center&quot; justify=&quot;center&quot; class=&quot;d-p-200 d-bgc-moderate d-code--sm d-ol-focusring-inset&quot;&gt;
  .d-ol-focusring-inset
&lt;/dt-stack&gt;
&lt;dt-stack direction=&quot;row&quot; align=&quot;center&quot; justify=&quot;center&quot; class=&quot;d-p-200 d-bgc-moderate d-code--sm d-ol-none&quot;&gt;
  .d-ol-none
&lt;/dt-stack&gt;'>
<dt-stack data-demo-wrapper direction="row" gap="200">
  <dt-stack direction="row" align="center" justify="center" class="d-p-200 d-bgc-moderate d-code--sm d-ol-focusring">
    .d-ol-focusring
  </dt-stack>
  <dt-stack direction="row" align="center" justify="center" class="d-p-200 d-bgc-moderate d-code--sm d-ol-focusring-inset">
    .d-ol-focusring-inset
  </dt-stack>
  <dt-stack direction="row" align="center" justify="center" class="d-p-200 d-bgc-moderate d-code--sm d-ol-none">
    .d-ol-none
  </dt-stack>
</dt-stack>
</code-example>
<ul class="d-docsite--unordered-list">
<li class="d-docsite--list-element">Use <code v-pre>d-ol-focusring</code> to add a focus ring that will render <strong>outside</strong> of the element.</li>
<li class="d-docsite--list-element">Use <code v-pre>d-ol-focusring-inset</code> to add a focus ring that renders <strong>within</strong> the edge of the element. This is particularly useful when the containing element bleeds to the edge of its parent or its <code v-pre>overflow</code> property is set to <code v-pre>hidden</code>.</li>
</ul>
<h2 id="classes" tabindex="-1" class="d-docsite--header-2">Classes <a class="header-anchor d-link d-docsite--link d-link" href="#classes" aria-hidden="true">#</a></h2>
<utility-class-table>
  <template #content>
    <tbody>
      <tr v-for="{ class: className, output } in outline">
        <th scope="row" class="d-code--sm d-docsite-code">.{{ className }}</th>
        <td class="d-code--sm">{{ output }}</td>
      </tr>
    </tbody>
  </template>
</utility-class-table>
</div></template>


<script setup>
  import { outline } from '@data/interactivity.json';
</script>